import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { type Control, useWatch } from 'react-hook-form';
import useDebounce from '@/helpers/hooks/useDebounce';
export type Subscription = {
  unsubscribe: () => void;
};
export const DEBOUNCE_MS = 300;
function useTriggerOnFormValueChanges(t0) {
  const $ = _c(13);
  const {
    trigger,
    validateAll,
    control
  } = t0;
  const inProgressRef = useRef(false);
  const calledWhileInProgressRef = useRef(false);
  let t1;
  if ($[0] !== trigger) {
    t1 = async () => {
      async function triggerAsync() {
        if (inProgressRef.current) {
          calledWhileInProgressRef.current = true;
          return;
        }
        inProgressRef.current = true;
        ;
        try {
          await trigger();
        } catch (t2) {
          const e = t2;
          console.error(e);
        }
        inProgressRef.current = false;
        if (!calledWhileInProgressRef.current) {
          return;
        }
        await triggerAsync();
        calledWhileInProgressRef.current = false;
      }
      return await triggerAsync();
    };
    $[0] = trigger;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safeTriggerAsync = t1;
  let t2;
  if ($[2] !== safeTriggerAsync) {
    t2 = () => void safeTriggerAsync().then();
    $[2] = safeTriggerAsync;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const safeTrigger = t2;
  const safeTriggerDebounced = useDebounce(safeTrigger, DEBOUNCE_MS);
  const t3 = control as Control<any, any, any>;
  let t4;
  if ($[4] !== t3) {
    t4 = {
      control: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const values = useWatch(t4);
  let t5;
  if ($[6] !== safeTriggerDebounced || $[7] !== validateAll) {
    t5 = () => {
      if (!validateAll) {
        return;
      }
      safeTriggerDebounced();
    };
    $[6] = safeTriggerDebounced;
    $[7] = validateAll;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== safeTriggerDebounced || $[10] !== validateAll || $[11] !== values) {
    t6 = [safeTriggerDebounced, validateAll, values];
    $[9] = safeTriggerDebounced;
    $[10] = validateAll;
    $[11] = values;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  useEffect(t5, t6);
}
export default useTriggerOnFormValueChanges;